import { call, put, takeEvery } from 'redux-saga/effects'
import * as invoiceActions from '@redux/ducks/invoiceDucks'
import * as invoiceApi from '@api/invoiceApi'

interface FetchListSaga {
  type: string
  payload: string
}

function* fetchListIncvoice({ payload: queryString }: FetchListSaga) {
  try {
    const res: ReturnType<typeof invoiceApi.getListInvoice> = yield call(invoiceApi.getListInvoice, queryString)
    yield put(invoiceActions.getListInvoiceSuccess(res))
  } catch (error) {
    yield put(invoiceActions.getListInvoiceFail(error))
  }
}



export default function* watchOrder() {
  yield takeEvery(invoiceActions.getListInvoice.toString(), fetchListIncvoice)
}
